var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovefoldericon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.389 7.8748H15.4008C15.8426 7.8748 16.2008 8.23298 16.2008 8.6748V13.3483V13.5748C16.2008 14.4032 15.5292 15.0748 14.7008 15.0748H3.60078M1.80078 3.72481V13.4998C1.80078 14.3697 2.50593 15.0748 3.37578 15.0748C4.24563 15.0748 4.95078 14.3697 4.95078 13.4998V8.6748C4.95078 8.23298 5.30895 7.8748 5.75078 7.8748H14.6008V5.98363C14.6008 5.5418 14.2426 5.18363 13.8008 5.18363H8.53019L7.30773 3.29078C7.16037 3.06262 6.90731 2.9248 6.6357 2.9248H2.60078C2.15895 2.9248 1.80078 3.28298 1.80078 3.72481Z",
    stroke: "#4F4D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovefoldericon);
export default __webpack_public_path__ + "static/media/movefoldericon.524409f5b0e873e9385aa67a9c5a56e3.svg";
export { ForwardRef as ReactComponent };